<google-map
    width="100vw"
    height="100vh"
    [center]="center"
    [zoom]="zoom"
    [options]="options"
>

@if (state >= 3 && detail != null) {
    @for (mapMarker of this.detail.mapInfo.mapMarkers; track mapMarker;) {
        <map-advanced-marker  [zIndex]="mapMarker.zIndex"  [position]="mapMarker.position"  [options]="mapMarker.options"/>
    }


    @for (attraction of this.attractionArray; track $index;) {
        <map-advanced-marker  [zIndex]="1"  [position]="{lat:attraction.lat, lng:attraction.lng}"  (mapClick)="showDetail($index)" />
    }

    @for (polyline of this.detail.mapInfo.polylines; track polyline;) {
        <map-polyline [path]="polyline.path" [options]="polyline.options"/>
    }
}
</google-map>
